module.exports = __webpack_public_path__ + "img/pressure.f32103df.svg";